<template>
	<v-container class="login-container">
		<!-- 로그인 화면 로고 -->
		<v-layout class="login-layout" wrap justify-center>
			<!-- <v-flex xs12 style="margin-bottom:80px; margin-top:100px;">
				<div class="text-center"></div>
			</v-flex> -->
			<!-- CDP -->

			<v-layout class="login_background" flex-wrap justify-center>
				<v-flex xs12>
					<div style="max-width:600px; margin:0 auto;">
						<v-img
							v-if="$route.params.code === 'xtamfw5gwxh'"
							contain
							src="https://api.here.re.kr:6010/uploads/2_f4c5909b36.png"
							height="500"
						></v-img>
						<div class="reserveLogin-mainTitle mt-4">
							대기고객 입장 어드민
						</div>
						<div class="text-center mt-4 px-4">
							<!-- 아이디 -->
							<v-text-field
								:error-messages="iderrorMessages"
								:autofocus="false"
								label="아이디"
								maxlength="255"
								height="50px"
								outlined
								:hideDetails="iderrorMessages === '' ? true : false"
								flat
								v-model="userid"
								@keydown.enter="login()"
								autocomplete="off"
								:class="iderrorMessages === '' ? 'mb-4' : ''"
							></v-text-field>
							<!-- 비밀번호 -->
							<v-text-field
								:error-messages="pwerrorMessages"
								:autofocus="false"
								label="비밀번호"
								type="password"
								height="50px"
								outlined
								:hideDetails="pwerrorMessages === '' ? true : false"
								maxlength="255"
								v-model="password"
								@keydown.enter="login()"
								autocomplete="off"
								:class="pwerrorMessages === '' ? 'mb-4' : ''"
							></v-text-field>
							<v-btn class="loginButton mt-4 mb-12" block elevation="0" @click="login()" color="PointColor1">
								<span style="color:white;	font-weight: bold;">
									로그인
								</span>
							</v-btn>
							<!-- <p class="footer-text">Don't have an account? <span class="signup-text" @click="toSignup">Sign Up</span></p> -->
						</div>
					</div>
				</v-flex>
			</v-layout>
			<!-- 하단 -->
		</v-layout>
	</v-container>
</template>

<script>
export default {
	data() {
		return {
			rememberId: false,
			alertModal2: {
				dialog: false,
				text: '',
			},
			// 아이디 에러메세지
			iderrorMessages: '',
			// 패스워드 에러메세지
			pwerrorMessages: '',
			// id,password 데이터
			userid: '',
			password: '',
			reservedayData: {},
		}
	},
	created() {
		if (this.$route.params.code === '09buhz2luv1') {
			this.$router.push({ name: 'reserveLogin', params: { code: '09buhz2luv' } })
		}
	},
	methods: {
		login() {
			if (!this.userid) {
				this.iderrorMessages = 'Please enter your ID.'
				return
			} else if (!this.password) {
				this.pwerrorMessages = 'Please enter your PASSWORD.'
				return
			} else {
				const data = {
					username: this.userid,
					password: this.password,
				}
				this.$store
					.dispatch('login', data)
					.then(() => {
						this.$router.push({ name: 'reserveAdmin', params: { code: this.$route.params.code } }).catch(() => {})
					})
					.catch(() => {
						this.iderrorMessages = 'Your ID or Password is incorrect.'
						this.pwerrorMessages = 'Your ID or Password is incorrect.'
					})
					.catch(() => {})
			}
		},
	},
}
</script>
<style lang="scss">
.reserveLogin-mainTitle {
	font-size: 24px;
	font-weight: bold;
}
</style>
